import { render } from "./HeartIcon.vue?vue&type=template&id=9712f4d8"
import script from "./HeartIcon.vue?vue&type=script&lang=js"
export * from "./HeartIcon.vue?vue&type=script&lang=js"

import "./HeartIcon.vue?vue&type=style&index=0&id=9712f4d8&lang=css"
script.render = render

export default script